import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    Card,
    CardContent,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Container,
    Checkbox,
    ListItemText,
    TextField,
} from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import Auth from '../services/auth';
import CollectorDataAccess from '../services/CollectorDataAccess';

const auth = new Auth();
const collectorDataAccess = new CollectorDataAccess();

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(3)
    },
    filterCard: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(0),
        paddingTop: theme.spacing(1)
    },
    inputLabel: {
        paddingLeft: 2,
        marginLeft: 18,
        marginTop: -10,
        width: '100%',
    },
    formControl: {
        width: '100%',
        paddingLeft: 5,
        minWidth: 120,
        marginRight: theme.spacing(2)
    },
    submitButton: {
        minHeight: 40,
        minWidth: 150,
        marginRight: theme.spacing(2)
    },
    tableContainer: {
        marginTop: theme.spacing(2),
        with: '100%',
        maxWidth: '100%',
        overflowX: "hidden",
    }, 
    emptyTable: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: theme.palette.text.secondary,
    },
    accessDenied: {
        textAlign: 'center',
        marginTop: theme.spacing(4)
    },
    actionsRow: {
        marginTop: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(2)
    },
    table: {
        tableLayout: "fixed",
        width: "100%",
        minWidth: "100%"
    },
    cell: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
});

class CollectorAssignment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasAccess: auth.isInADDGroup(),
            selectedSystem: '',
            selectedClient: '',
            tableData: [],
            showConfirmDialog: false,
            hasUnsavedChanges: false,
            showConfirmBeforeToSave: false,
            blockButton : false, 
            pendingAction: null,
            systems: [],
            clients: [],
            financialClasses : [],
            statusCodes:  [],
            collectors: []

        };

        // Bind methods
        this.handleSystemChange = this.handleSystemChange.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleResetFilters = this.handleResetFilters.bind(this);
        //this.handleSubmitChanges = this.handleSubmitChanges.bind(this);
        this.handleConfirmDialog = this.handleConfirmDialog.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.checkUnsavedChanges = this.checkUnsavedChanges.bind(this);
        this.confirmSave = this.confirmSave.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
    }
    tempIdCounter = -1;

    componentDidMount() {
        document.title = 'Collectors - Surgical Notes RCM';

        // Add beforeunload listener for browser/tab close
        window.addEventListener('beforeunload', this.handleBeforeUnload);

        this.loadSystems();
        this.loadCollectors();
        this.loadStatusCodes();
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleBeforeUnload = (e) => {
        if (this.state.hasUnsavedChanges) {
            e.preventDefault();
            e.returnValue = '';
        }
    };

    checkUnsavedChanges(callback) {
        if (this.state.hasUnsavedChanges) {
            this.setState({
                showConfirmDialog: true,
                pendingAction: callback
            });
        } else {
            callback();
        }
    }


    handleSystemChange = (event) => {
        const newSystem = event.target.value;

        this.checkUnsavedChanges(() => {
            this.setState({
                selectedSystem: newSystem,
                selectedClient: '',
                hasUnsavedChanges: false,
                clients: []
                // Don't update tableData here - wait for search button
            });
        });

        if (!newSystem) return;

        try {
            collectorDataAccess.getClientsBySystem(newSystem).then((rs) => {
                if (rs) {
                    this.setState({ clients: rs, isLoading: false });
                } else {
                    this.handleError("No clients configured for selected system " + newSystem);
                    this.setState({ isLoading: false });
                }
            });
        } catch (error) {
            this.handleError(error);
            window.alert("No clients configured for selected system " + newSystem);
            this.setState({ isLoading: false });
        }
    };


    handleResetFilters = () => {
        this.checkUnsavedChanges(() => {
            this.setState({
                selectedSystem: '',
                selectedClient: '',
                tableData: [],
                hasUnsavedChanges: false
            });
        });
    };


    handleFieldChange = (index, field, newValue) => {
        this.setState((prevState) => {
            const updated = [...prevState.tableData];
            updated[index][field] = newValue; 

            const changedRows = { ...prevState.changedRows };
            changedRows[updated[index].id] = updated[index];

            return { tableData: updated, changedRows, hasUnsavedChanges: true };
        });
    };

    confirmSave = () => {

        if (Object.keys(this.state.changedRows).length === 0)
            return;

        this.setState({ showConfirmBeforeToSave: true });
    };

    saveChanges = async () => {
        try {

            const rowsToUpdate = Object.values(this.state.changedRows).map(this.normalizeRowByType);;
            const userName = auth.getUserEmail();
            if (rowsToUpdate.length === 0)
                return;

            this.setState({ isLoading: true, blockButton: true });
            await collectorDataAccess.processCollectors(rowsToUpdate,userName);

            this.setState({ changedRows: {}, showConfirmBeforeToSave: false, isLoading: false, blockButton: false, hasUnsavedChanges: false })
            this.handleSearch();
            alert('Changes submitted successfully!');

        } catch (error) {
            this.setState({ isLoading: false, showConfirmBeforeToSave: false, blockButton: false });
            //this.handleError(error);
            window.alert("Error saving changes: ${error.message || error}");
        }
    };

    normalizeRowByType = (row) => {
        const newRow = { ...row };

        if (newRow.type.includes('All')) {
            newRow.finClass = null;
            newRow.statusCode = null;
            newRow.dos = null;
            newRow.dosOperator = null;
            newRow.patientNameStart = null;
            newRow.patientNameEnd = null;
        } else {
            if (!newRow.type.includes('Financial Class')) newRow.finClass = null;
            if (!newRow.type.includes('Status Code')) newRow.statusCode = null;
            if (!newRow.type.includes('DOS')) {
                newRow.dos = null;
                newRow.dosOperator = null;
            }
            if (!newRow.type.includes('Patient Name')) {
                newRow.patientNameStart = null;
                newRow.patientNameEnd = null;
            }
        }

        return newRow;
    }


    handleConfirmDialog = (confirmed) => {
        if (confirmed && this.state.pendingAction) {
            this.setState({
                showConfirmDialog: false,
                hasUnsavedChanges: false
            }, () => {
                this.state.pendingAction();
            });
        } else {
            this.setState({
                showConfirmDialog: false,
                pendingAction: null
            });
        }
    };


    handleClientChange = (event) => {
        const newClient = event.target.value;
        
        this.checkUnsavedChanges(() => {
            this.setState({
                selectedClient: newClient,
                hasUnsavedChanges: false
            }, () => {
                this.loadFinancialClass();
            });
        });

    };

    handleSearch = () => {
        if (this.state.selectedSystem && this.state.selectedClient) {
            try {
                collectorDataAccess.getFilteredData(this.state.selectedSystem, this.state.selectedClient).then((rs) => {
                    if (rs) {
                        const processedData = rs.map(row => ({
                            ...row,
                            type: JSON.parse(row.type),
                            finClass: JSON.parse(row.finClass),
                            statusCode: JSON.parse(row.statusCode)
                        }));
                        this.setState({ tableData: processedData, isLoading: false, hasUnsavedChanges: false })
                    } else {
                        this.handleError("No feteched data for selected filters");
                        this.setState({ isLoading: false });
                    }
                });
            } catch (error) {
                this.handleError(error);
                window.alert("No feteched data for selected filters");
                this.setState({ isLoading: false });
            }
        }
    };

    handleConfirmDialogClose = (confirmed) => {
        if (confirmed && this.state.pendingAction) {
            this.state.pendingAction();
            this.setState({
                showConfirmDialog: false,
                pendingAction: null
            });
        } else {
            this.setState({
                showConfirmDialog: false,
                pendingAction: null
            });
        }
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    handleAddNew = () => {
        const newRow = {
            id: this.tempIdCounter--,
            FacilityID: this.state.selectedClient,
            type: [],
            finClass: [],
            statusCode: [],
            dosOperator: '',
            dos: '',
            patientNameStart: '',
            patientNameEnd: '',
            collector: '',
            
        };
        this.setState(prev => ({ tableData: [...prev.tableData, newRow], editingRowId: this.tempIdCounter }));
    };

    handleTypeChange = (rowId, value) => {
        let newTypes = typeof value === 'string' ? [value] : value;
        const lastSelected = newTypes[newTypes.length - 1];
        if (lastSelected === 'All') {
            newTypes = ['All'];
        } else {
            newTypes = newTypes.filter(v => v !== 'All');
        }
        this.setState(prev => ({
            tableData: prev.tableData.map(r => r.id === rowId ? { ...r, type: newTypes } : r)
        }));
    };

    loadSystems() {

        this.setState({ isLoading: true });

        try {
            collectorDataAccess.getSystems().then((rs) => {
                if (rs) {
                    this.setState({ systems: rs, isLoading: false });
                } else {
                    this.handleError('No systems configured');
                    this.setState({ isLoading: false });
                }
            });
        } catch (error) {
            this.handleError(error);
            window.alert('No systems configured');
            this.setState({ isLoading: false });
            return;
        }
    };

    loadCollectors() {

        this.setState({ isLoading: true });

        try {
            collectorDataAccess.getCollectors().then((rs) => {
                if (rs) {
                    this.setState({ collectors: rs, isLoading: false });
                } else {
                    this.handleError('No collectors configured');
                    this.setState({ isLoading: false });
                }
            });
        } catch (error) {
            this.handleError(error);
            window.alert('No collectors configured');
            this.setState({ isLoading: false });
            return;
        }
    };

    loadStatusCodes() {

        this.setState({ isLoading: true });

        try {
            collectorDataAccess.getStatusCodes().then((rs) => {
                if (rs) {
                    this.setState({ statusCodes: rs, isLoading: false });
                } else {
                    this.handleError('No status codes configured');
                    this.setState({ isLoading: false });
                }
            });
        } catch (error) {
            this.handleError(error);
            window.alert('No status codes configured');
            this.setState({ isLoading: false });
            return;
        }
    };

    loadFinancialClass() {

        this.setState({ isLoading: true });

        try {
            collectorDataAccess.getFinancialClass(this.state.selectedSystem, this.state.selectedClient).then((rs) => {
                if (rs) {
                    this.setState({ financialClasses: rs, isLoading: false });
                } else {
                    this.handleError('No status codes configured');
                    this.setState({ isLoading: false });
                }
            });
        } catch (error) {
            this.handleError(error);
            window.alert('No status codes configured');
            this.setState({ isLoading: false });
            return;
        }
    };

    renderControlByType = (t, index, row, isEditing) => {
        const { classes } = this.props;
        switch (t) {
            case 'Financial Class':
                return (
                    <FormControl className={classes.formControl}>
                        <Select
                            multiple
                            value={row.finClass || []}
                            onChange={(e) => this.handleFieldChange(index, 'finClass', e.target.value)}
                            disabled={!isEditing}
                            renderValue={(sel) => (sel || []).join(', ')}
                        >
                            {this.state.financialClasses.map(fc => (
                                <MenuItem key={fc.FinancialClass} value={fc.FinancialClass}>
                                    <Checkbox checked={(row.finClass || []).includes(fc.FinancialClass)} />
                                    <ListItemText primary={fc.FinancialClass} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            case 'Status Code':
                return (
                    <FormControl className={classes.formControl}>
                        <Select
                            multiple
                            value={row.statusCode || []}
                            onChange={(e) => this.handleFieldChange(index, 'statusCode', e.target.value)}
                            disabled={!isEditing}
                            renderValue={(sel) => (sel || []).join(', ')}
                        >
                            {this.state.statusCodes.map(sc => (
                                <MenuItem key={sc.StatusCode} value={sc.StatusCode}>
                                    <Checkbox checked={(row.statusCode || []).includes(sc.StatusCode)} />
                                    <ListItemText primary={sc.StatusCode} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            case 'DOS':
                return (
                    <Grid container spacing={1}>
                        <Grid item>
                            <FormControl className={classes.formControl}>
                                <Select
                                    value={row.dosOperator || ''}
                                    onChange={(e) => this.handleFieldChange(index, 'dosOperator', e.target.value)}
                                    disabled={!isEditing}
                                >
                                    <MenuItem value="<">{'<'}</MenuItem>
                                    <MenuItem value=">">{'>'}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <TextField
                                type="date"
                                value={row.dos || ''}
                                onChange={(e) => this.handleFieldChange(index, 'dos', e.target.value)}
                                disabled={!isEditing}
                            />
                        </Grid>
                    </Grid>
                );
            case 'Patient Name':
                return (
                    <Grid container spacing={1}>
                        <Grid item>
                            <FormControl className={classes.formControl}>
                                <Select
                                    value={row.patientNameStart || ''}
                                    onChange={(e) => this.handleFieldChange(index, 'patientNameStart', e.target.value)}
                                    disabled={!isEditing}
                                >
                                    {'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl className={classes.formControl}>
                                <Select
                                    value={row.patientNameEnd || ''}
                                    onChange={(e) => this.handleFieldChange(index, 'patientNameEnd', e.target.value)}
                                    disabled={!isEditing}
                                >
                                    {'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                );
            case 'All':
            default:
                return <em>No selection</em>;
        }
    };

    renderTypeSpecificFields = (index,row, isEditing) => {
        return row.type.map(t => (
            <div key={t} style={{ marginBottom: 8 }}>
                <strong>{t}:</strong> {this.renderControlByType(t,index, row, isEditing)}
            </div>
        ));
    };

    render() {
        const { classes } = this.props;
        const { hasAccess, selectedSystem, selectedClient, tableData, systems, clients, hasUnsavedChanges, showConfirmBeforeToSave, blockButton } = this.state;

        if (!hasAccess) {
            return <Redirect to="/" />;
        }

        return (
            <Container maxWidth="xl" className={classes.root}>
                <h2>Collector Assignment</h2>
                
                <Card className={classes.filterCard}>
                    <CardContent>                        
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={4} md={2}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel
                                        id="System"
                                        className={classes.inputLabel}>System</InputLabel>
                                    <Select
                                        value={selectedSystem}
                                        onChange={this.handleSystemChange}
                                        id="System"
                                        labelId="System"
                                        variant="outlined"
                                        margin="dense"
                                        label="System"
                                        fullWidth
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>Select System</em>
                                        </MenuItem>
                                        {systems.map((system) => (
                                            <MenuItem key={system.SystemId} value={system.SystemId}>
                                                {system.SystemId}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            <Grid item xs={12} sm={4} md={2}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel
                                        id="Client"
                                        className={classes.inputLabel}>Client</InputLabel>
                                    <Select
                                        value={selectedClient}
                                        onChange={this.handleClientChange}
                                        disabled={!selectedSystem}
                                        id="Client"
                                        labelId="Client"
                                        variant="outlined"
                                        margin="dense"
                                        label="Client"
                                        fullWidth
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>Select Client</em>
                                        </MenuItem>
                                        {clients.map((client) => (
                                            <MenuItem key={client.Account} value={client.Account}>
                                                {client.Facility}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            <Grid item xs={12} sm={4} md={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.submitButton}
                                    disabled={!selectedSystem || !selectedClient}
                                    onClick={this.handleSearch}
                                >
                                    Search
                                </Button>
                            </Grid>
                            
                            <Grid item xs={12} sm={4} md={2}>
                                <Button
                                    variant="outlined"
                                    color="default"
                                    className={classes.submitButton}
                                    disabled={!selectedSystem && !selectedClient}
                                    onClick={this.handleResetFilters}
                                >
                                    Reset Filters
                                </Button>
                            </Grid>

                            <Grid item xs={12} sm={4} md={2}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className={classes.handleSubmitChanges}
                                    disabled={!hasUnsavedChanges}
                                    onClick={this.confirmSave}
                                >
                                    Submit Changes
                                </Button>
                            </Grid>

                            <Grid item xs={12} sm={4} md={2}>
                                <Button variant="outlined" disabled={!selectedSystem || !selectedClient} color="primary" onClick={this.handleAddNew}>
                                    Add New
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table className={classes.table}>
                        <TableHead>
                            {tableData.length !== 0 ? (
                                <TableRow>
                                    <TableCell>Type</TableCell>
                                    <TableCell className={classes.cell}>Selection</TableCell>
                                    <TableCell>Collector</TableCell>
                                </TableRow>
                            ) : (<TableRow></TableRow>)}
                        </TableHead>
                        <TableBody>
                            {tableData.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={10} className={classes.emptyTable}>
                                        {selectedSystem && selectedClient
                                            ? 'Click Search to load data for the selected filters'
                                            : 'Please select System and Client, then click Search to view data'
                                        }
                                    </TableCell>
                                </TableRow>
                            ) : (
                                    tableData.map((row,index) => {
                                        const isEditing = true; // this.state.editingRowId === row.id;
                                        return (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <Select
                                                    multiple
                                                    value={row.type}
                                                    onChange={(e) => this.handleTypeChange(row.id,e.target.value)}
                                                    disabled={!isEditing}
                                                    renderValue={(val) => val.join(', ')}
                                                >
                                                    {['Financial Class', 'Status Code', 'DOS', 'Patient Name', 'All'].map(t => (
                                                        <MenuItem key={t} value={t}>
                                                            <Checkbox checked={row.type.includes(t)} />
                                                            <ListItemText primary={t} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </TableCell>
                                        <TableCell>{this.renderTypeSpecificFields(index,row, isEditing)}</TableCell>
                                        <TableCell>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <Select
                                                    value={row.collector || ''}
                                                    onChange={(e) => this.handleFieldChange(index,'collector', e.target.value)}
                                                    disabled={!isEditing}
                                                >
                                                            <MenuItem value=""><em>Select Collector</em></MenuItem>
                                                            {this.state.collectors.map(c => <MenuItem key={c.collector} value={c.collector}>{c.collector}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </TableCell>
                                    </TableRow>
                                )})
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>



                {/* Confirmation Dialog */}
                <Dialog
                    open={this.state.showConfirmDialog}
                    onClose={() => this.handleConfirmDialogClose(false)}
                >
                    <DialogTitle>Confirm Action</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            You have unsaved changes. Are you sure you want to continue? All unsaved changes will be lost.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.handleConfirmDialogClose(false)} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={() => this.handleConfirmDialogClose(true)} color="primary" autoFocus>
                            Continue
                        </Button>
                    </DialogActions>
                </Dialog>

                {showConfirmBeforeToSave && (
                    <Dialog
                        open={showConfirmBeforeToSave}
                        onClose={() => this.setState({ showConfirmBeforeToSave: false })}
                    >
                        <DialogTitle>Confirm changes</DialogTitle>
                        <DialogContent>
                            <p>The following changes will be saved:</p>
                            <ul>
                                {Object.values(this.state.changedRows).map((row) => (
                                    <li key={row.id}>
                                        {row.FacilityID} - {row.type.join(', ')} - {row.collector} 
                                    </li>
                                ))}
                            </ul>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.submitButton}
                                disabled={blockButton}
                                onClick={() => this.setState({ showConfirmBeforeToSave: false })}>Cancel</Button>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.submitButton}
                                disabled={blockButton}
                                onClick={this.saveChanges} >Confirm</Button>
                        </DialogActions>
                    </Dialog>
                )}

            </Container>
        );
    }
}

CollectorAssignment.displayName = 'CollectorAssignment';

export default withStyles(styles)(CollectorAssignment);
